import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "rsuite";

export default function PickPhotosModal({
  showModal,
  setShowModal,
  currentNumberOfPhotos,
  photos,
  initialPhotos,
  onSave,
}) {
  const [selectedPhotos, setSelectedPhotos] = useState(initialPhotos);

  const pluralize = (num: number) => (num > 1 ? "s" : "");

  const addPhoto = (photo: any) => {
    setSelectedPhotos([
      ...selectedPhotos,
      photos.find((p) => p.urls[0].url === photo.original),
    ]);
  };

  const removePhoto = (photo: any) => {
    setSelectedPhotos(
      selectedPhotos.filter((el) => el.urls[0].url !== photo.original)
    );
  };

  const clearSelectedPhotos = () => {
    setSelectedPhotos([]);
  };

  const handleCancel = () => {
    setSelectedPhotos(initialPhotos);
    setShowModal(false);
  };

  const handleSave = () => {
    onSave(selectedPhotos);
    setShowModal(false);
  };

  useEffect(() => {
    setSelectedPhotos(initialPhotos);
  }, [initialPhotos]);

  return (
    <Modal size="lg" show={showModal} onHide={handleCancel}>
      <Modal.Header>
        <div
          style={{
            display: "flex",
            gap: 20,
            alignItems: "center",
          }}
        >
          <p style={{ fontSize: 18, fontWeight: 500 }}>
            Select {selectedPhotos.length} of {currentNumberOfPhotos} Photo
            {pluralize(currentNumberOfPhotos)}
          </p>
          {selectedPhotos.length > 0 && (
            <Button size="xs" color="red" onClick={clearSelectedPhotos}>
              Clear Selected Photo{pluralize(currentNumberOfPhotos)}
            </Button>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
          {getPhotos(photos || []).map((photo, index) => {
            const isSelected = selectedPhotos.find(
              (p) => p.urls[0].url === photo.original
            );
            return (
              <div
                key={photo.xs}
                style={{
                  width: "24%",
                  height: 200,
                  backgroundColor: "#f2f2f2",
                  position: "relative",
                  borderRadius: 4,
                  opacity:
                    !isSelected &&
                    selectedPhotos.length >= currentNumberOfPhotos
                      ? 0.6
                      : 1,
                  cursor:
                    !isSelected &&
                    selectedPhotos.length >= currentNumberOfPhotos
                      ? "not-allowed"
                      : "pointer",
                }}
                onClick={() =>
                  !isSelected &&
                  selectedPhotos.length < currentNumberOfPhotos &&
                  addPhoto(photo)
                }
              >
                <div
                  style={{
                    position: "absolute",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 26,
                    color: "black",
                    textShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                    fontWeight: 700,
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(208, 208, 32, 0.5)",
                    opacity: isSelected ? 1 : 0,
                  }}
                >
                  {selectedPhotos.findIndex(
                    (p) => p.urls[0].url === photo.original
                  ) + 1}
                  <Button
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      backgroundColor: "black",
                      border: "1px solid black",
                      color: "white",
                    }}
                    size="xs"
                    onClick={(evt) => {
                      evt.stopPropagation();
                      removePhoto(photo);
                    }}
                  >
                    X
                  </Button>
                </div>
                <img
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={photo.xs}
                  alt={`p-${index}`}
                />
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginTop: 20 }}>
        <Button appearance="subtle" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          disabled={selectedPhotos.length < currentNumberOfPhotos}
          appearance="primary"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export function getPhotos(photos = []) {
  return photos.map((item) => ({
    original: get(
      item.urls.find((el) => el.size === "orig"),
      "url"
    ),
    xs: get(
      item.urls.find((el) => el.size === "500x380"),
      "url"
    ),
    md: get(
      item.urls.find((el) => el.size === "1024x1024"),
      "url"
    ),
    xl:
      get(
        item.urls.find((el) => el.size === "2560x1440"),
        "url"
      ) ||
      get(
        item.urls.find((el) => el.size === "1920x1080"),
        "url"
      ) ||
      get(
        item.urls.find((el) => el.size === "1600x900"),
        "url"
      ),
  }));
}
